import PriceUtils from '../main/core/price-utils';

declare let core_object: any;
declare const gtag: any;
declare const dataLayer: any;

const priceUtils = new PriceUtils();

export default class googleAdv{ 

    /**
     * Capture GTM Event
     * @param room 
     * @param value 
     * @param transaction_id 
     */
    captureGtmEvent(room: number | undefined, value: string | undefined, transaction_id: string | undefined) {
        
        try{
            
            if (this.isGTMInstalled()) {
                
                const price = priceUtils.normalizeToDotDecimal(value);

                room = Number(room);

                switch(room){
                    
                    // Milano
                    case 1:
                        
                        dataLayer.push({
                            event: "purchase_reservation",
                            transaction_id: transaction_id,
                            value: price,
                            currency: "EUR"
                        });
                        
                    break;

                }
                
            }
            
        }catch(error){
            
            console.log(error);
            
        }

    }

    /**
     * Capture Event
     * @param room 
     * @param value 
     * @param transaction_id 
     */
    captureEvent(room: number | undefined, value: string | undefined, transaction_id: string | undefined) {
        
        try{
            
            if(typeof gtag !== 'undefined'){ 

                const price = value?.replace(/&nbsp;€/g, "");

                room = Number(room);

                switch (room) {
                    
                    // Milano
                    case 1:

                        // gtag('event', 'conversion', {
                        //     'send_to': 'AW-11039957155/w-fgCNj0hI4bEKPBoZAp',
                        //     'value': price,
                        //     'currency': 'EUR',
                        //     'transaction_id': transaction_id
                        // });
                        
                    break;
                    
                    // Cerro Maggiore
                    // case 2:

                    //     gtag('event', 'conversion', {
                    //         'send_to': 'AW-17097838611/wURyCJTtgNoaEJOg8dg_',
                    //         'value': price,
                    //         'currency': 'EUR',
                    //         'transaction_id': transaction_id
                    //     });
                        
                    // break;
                    
                    // Genova
                    // case 4:
                        
                    //     gtag('event', 'conversion', {
                    //         'send_to': 'AW-17097838611/UgunCLWXjdoaEJOg8dg_',
                    //         'value': price,
                    //         'currency': 'EUR',
                    //         'transaction_id': transaction_id
                    //     });
                        
                    // break;
                    
                    // Perugia
                    // case 8:

                    //     gtag('event', 'conversion', {
                    //         'send_to': 'AW-17097838611/LJ5YCO_C-tkaEJOg8dg_',
                    //         'value': price,
                    //         'currency': 'EUR',
                    //         'transaction_id': transaction_id
                    //     });
                        
                    // break;
                    
                    // Latina
                    // case 11:

                    //     gtag('event', 'conversion', {
                    //         'send_to': 'AW-17097838611/u1ocCPqRjdoaEJOg8dg_',
                    //         'value': price,
                    //         'currency': 'EUR',
                    //         'transaction_id': transaction_id
                    //     });
                        
                    // break;
                    
                }

            }
            
        }catch(error){
            
            console.log(error);
            
        }
        
    }


    // Check if dataLayer exists and is an array
    isGTMInstalled(){
        
        // GTM always defines window.dataLayer as an array
        return Array.isArray((window as any).dataLayer);

    }

}